export default __webpack_public_path__ + "84a57884dba61aab51d60750efa63832.svg";